import * as yup from "yup";

export const complementoSchema = yup.object().shape({
    descricao: yup.string().required('Nome inválido')
});